/**
 * AIConsentRenew.jsx — PROD-1225, route /ai-consent/renew.
 *
 * The re-consent screen. Reached two ways: the server's AI consent gate refused a call
 * (403 `ai_consent_required` -> window event -> App.jsx listener), or the once-per-session
 * launch check found `enforced && !consented`. Both carry `state.returnTo`.
 *
 * It is OnboardingAIConsent in mode="reconsent". Two choices only (Alex 2026-10-21, Q4):
 *   - "Agree & Continue": OnboardingAIConsent records the consent (aiConsentAPI.record), then
 *     this marks the launch check consented and returns the patient to where they were;
 *   - Sign out, from the "What if I don't agree?" note: the same sign-out as the menu's. The
 *     account and its cases stay; the screen comes first again at the next sign-in.
 * No AI-off mode and no delete button here; deleting stays in Settings.
 */
import { useLocation, useNavigate } from 'react-router-dom'
import OnboardingAIConsent from './OnboardingAIConsent'
import { useUserStore } from '../../stores'
import { unsubscribePushOnServer } from '../../services/push'
import { aiConsentLaunch } from '../../services/aiConsentLaunch'
import { safeReturnPath } from '../../utils/aiConsentSignal'

export default function AIConsentRenew() {
  const navigate = useNavigate()
  const location = useLocation()
  const returnTo = safeReturnPath(location.state?.returnTo)

  const done = () => {
    aiConsentLaunch.markConsented()
    navigate(returnTo, { replace: true })
  }

  const signOut = async () => {
    // The menu's sign-out (HamburgerMenu handleLogout): push endpoint first, while the token is valid.
    try { await unsubscribePushOnServer() } catch (_) {}
    aiConsentLaunch.reset()
    useUserStore.getState().logout()
    navigate('/signin', { replace: true })
  }

  return <OnboardingAIConsent mode="reconsent" onNext={done} onSignOut={signOut} />
}
